<template>
  <b-navbar toggleable="sm" type="light" variant="light" class="mt-n4 mb-4 border" :sticky="true">
    <b-navbar-brand href="#">
      ID: {{ r.code }}
    </b-navbar-brand>

    <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
    <b-navbar-toggle target="nav-collapse-r">
      <template #default="{ expanded }">
        <font-awesome-icon v-if="expanded" :icon="['fas', 'ellipsis-v']"/>
        <font-awesome-icon v-else :icon="['fas', 'ellipsis-v']"/>
        <!-- <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
        <b-icon v-else icon="chevron-bar-down"></b-icon> -->
      </template>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse-r" is-nav>
      <b-navbar-nav>
        <b-nav-item href="#"><small> Creada {{ $moment(r.created_at).format('YYYY-MM-DD HH:mm:ss') }}</small></b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-form>
          <b-button size="sm" @click="emitSave" class="my-2 my-sm-0" variant="primary" >Guardar</b-button>
        </b-nav-form>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'HeadReservationSupervisor',
    components:{FontAwesomeIcon},
    props:['reservation'],
    data() {
      return {
        r: this.reservation
      }
    },
    methods: {
      emitSave() {
        this.$emit('click-save-btn', {})
      }
    }
  }
</script>